module.exports = __webpack_public_path__ + "media/images/icon-info-6e1872208d25bedac59725ab16747717.svg";